import { Component, inject, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { Title } from '@angular/platform-browser';
import { register } from 'swiper/element/bundle';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SplashScreen } from '@capacitor/splash-screen';
import { Geolocation } from '@capacitor/geolocation';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import { AnalyticsService } from './services/analytics.service';
import { UpdateService } from './services/update.service';
import { BrandService } from './services/brands.service';
import { AuthService } from './services/auth.service';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {

  private analytics = inject(AnalyticsService)
  private router = inject(Router);
  private platform = inject(Platform)

  private tabRoots = [
    '/misuper/beranda',
    '/misuper/pesanan',
    '/misuper/menu',
    '/misuper/profile',
    '/superkoffee/beranda',
    '/superkoffee/pesanan',
    '/superkoffee/menu',
    '/superkoffee/profile',
  ];
  private standaloneRoots = [
    '/auth',
  ];
  private lastBack = 0;

  constructor(private updateService: UpdateService,
    private brandService: BrandService,
    private authService: AuthService,
    private title: Title) {

    this.splash()

    this.platform.ready().then(() => {
      this.authService.reinitPush()
      this.registerBackButton();
      this.getLoc()
    });
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const screenName = event.urlAfterRedirects;
        this.analytics.setScreenName(screenName);
      }
      if (event instanceof NavigationStart) {
        const screenName = event.url
        const brand = screenName.split('/')[1];
        if (brand == 'misuper' || brand == 'superkoffee') {
          sessionStorage.setItem("target", brand);
          this.brandService.setBrand(brand)
        } else {
          this.brandService.setBrand('misuper')
        }
        this.title.setTitle(this.brandService.getBrand().title);
      }
    });
  }

  async getLoc() {
    
    let status = await Geolocation.checkPermissions()

    if(status.location == 'prompt' && Capacitor.getPlatform() != 'web') {
      await Geolocation.requestPermissions();
    }

    if (status.location === 'granted' || Capacitor.getPlatform() === 'web') {
      const coordinates = await Geolocation.getCurrentPosition();
      let location = {
        latitude: coordinates.coords.latitude,
        longitude: coordinates.coords.longitude
      }
      console.log(location)
      localStorage.setItem("location", JSON.stringify(location))
    }
    if (status.location === 'denied') {
      localStorage.setItem("location", "denied")
    }
  }

  async splash() {
    await SplashScreen.show({
      showDuration: 1000,
      autoHide: true
    })
  }

  private registerBackButton() {
    this.platform.backButton.subscribeWithPriority(10, () => {
      const url = this.router.url.split('?')[0];

      // 🔚 Exit if on a tab root
      if (this.tabRoots.includes(url)) {
        this.exitWithDoubleBack();
        return;
      }

      // 🔚 Exit if on auth root
      if (this.standaloneRoots.some(r => url.startsWith(r))) {
        App.exitApp();
        return;
      }

      // 🔙 Default behavior
      window.history.back();
    });
  }

  private exitWithDoubleBack() {
    const now = Date.now();
    if (now - this.lastBack < 2000) {
      App.exitApp();
    } else {
      this.lastBack = now;
      console.log('Press back again to exit'); // replace with Toast if needed
    }
  }
}
